import { PropTypes } from 'prop-types';
import React, { forwardRef, useImperativeHandle } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import Detergent from '../models';
import DetergentReadingEditFields from './DetergentReadingEditFields';

const DetergentReadingEditForm = forwardRef(function DetergentReadingEditForm(
  { detergents, initialValues, onSubmit },
  ref
) {
  const methods = useForm({
    defaultValues: initialValues || { readings: [] },
  });

  useImperativeHandle(ref, () => ({
    submit: () => methods.handleSubmit(onSubmit)(),
  }));

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <DetergentReadingEditFields detergents={detergents} name="readings" />
      </form>
    </FormProvider>
  );
});

DetergentReadingEditForm.propTypes = {
  detergents: PropTypes.arrayOf(PropTypes.instanceOf(Detergent)),
  initialValues: PropTypes.shape({}),
  onSubmit: PropTypes.func,
};

export default DetergentReadingEditForm;
